import { ShoesState } from 'src/types'
import { generateLiningsGradient, startInversion, undoInversion } from 'src/util/canvas'
import { canvasResetter } from 'src/util/canvas'
import { generateMesh } from './parts/meshMatrial'
import { gripWarts } from './parts/outSoles/runningShoesSole'
import { darkenColor } from 'src/util/color'
import { getUpperMaterial } from 'src/features/atoms/shoes/logic'
import { shoesHealDecorationEmbroidery, shoesHealEmbroidery } from './embroidery'

const rightFootTransform = (ctx: CanvasRenderingContext2D, callback: () => void, x = 0, y = 0) => {
  ctx.transform(1, 0.1, -0.2, 1, 45 + x, -42 + y) // sin, cos, -sin, -cos, x, y
  callback()
  ctx.setTransform(1, 0, 0, 1, 0, 0)
}

const leftFootTransform = (ctx: CanvasRenderingContext2D, callback: () => void, x = 0, y = 0) => {
  ctx.transform(1, -0.1, 0.2, 1, -40 + x, 45 + y) // sin, cos, -sin, -cos, x, y
  callback()
  ctx.setTransform(1, 0, 0, 1, 0, 0)
}

const outSole = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const pointOutSole = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = '#fff'
    ctx.lineWidth = 1.0
    ctx.beginPath()
    ctx.moveTo(0, 525) // 左上
    // ソール突入_半時計回りで描画
    ctx.quadraticCurveTo(69, 515, 69, 515) // ソール中間_左
    ctx.quadraticCurveTo(98, 503, 124, 525) // ソール中間_右
    ctx.quadraticCurveTo(142, 538, 172, 556)
    ctx.quadraticCurveTo(267, 588, 369, 568)
    ctx.quadraticCurveTo(401, 561, 418, 543)
    ctx.quadraticCurveTo(429, 527, 430, 489) // ソール右上
    ctx.quadraticCurveTo(425, 525, 318, 531)
    ctx.quadraticCurveTo(204, 529, 122, 504) // かかと本体左下
    ctx.quadraticCurveTo(91, 493, 36, 500)
    ctx.quadraticCurveTo(0, 504, 0, 504)
    ctx.quadraticCurveTo(0, 525, 0, 525)
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // 歯の描画_1
    ctx.beginPath()
    ctx.moveTo(0, 524) // 左上
    ctx.quadraticCurveTo(0, 549, 0, 549)
    ctx.quadraticCurveTo(12, 553, 13, 547)
    ctx.quadraticCurveTo(15, 549, 15, 549)
    ctx.quadraticCurveTo(26, 552, 31, 545)
    ctx.quadraticCurveTo(35, 519, 35, 519)
    ctx.quadraticCurveTo(0, 524, 0, 524)
    // ctx.quadraticCurveTo()
    ctx.fill()
    ctx.moveTo(26, 525)
    ctx.quadraticCurveTo(26, 540, 26, 540)
    ctx.stroke()
    ctx.closePath()

    // // 歯の描画_2
    ctx.beginPath()
    ctx.moveTo(170, 555) // 左上
    ctx.quadraticCurveTo(180, 584, 180, 584)
    ctx.quadraticCurveTo(186, 588, 188, 585)
    ctx.quadraticCurveTo(189, 587, 189, 587)
    ctx.quadraticCurveTo(208, 595, 211, 590)
    ctx.quadraticCurveTo(212, 593, 212, 593)
    ctx.quadraticCurveTo(224, 599, 231, 588)
    ctx.quadraticCurveTo(233, 570, 233, 570)
    ctx.quadraticCurveTo(205, 569, 170, 555)
    ctx.fill()
    ctx.moveTo(224, 573)
    ctx.quadraticCurveTo(224, 590, 224, 590)
    // ctx.quadraticCurveTo()
    ctx.stroke()
    ctx.closePath()

    // // 歯の描画_3
    ctx.beginPath()
    ctx.moveTo(288, 576) // 左上
    ctx.quadraticCurveTo(298, 604, 298, 604)
    ctx.quadraticCurveTo(315, 604, 315, 604)
    ctx.quadraticCurveTo(317, 600, 317, 600)
    ctx.quadraticCurveTo(319, 604, 319, 604)
    ctx.quadraticCurveTo(342, 606, 342, 599)
    ctx.quadraticCurveTo(344, 603, 344, 603)
    ctx.quadraticCurveTo(359, 600, 359, 600) //  右下
    ctx.quadraticCurveTo(366, 569, 366, 569)
    ctx.quadraticCurveTo(330, 577, 288, 576)
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.strokeStyle = '#383838'
    // ソール上のデザイン線
    ctx.beginPath()
    ctx.moveTo(1, 513) // 左端
    ctx.quadraticCurveTo(29, 516, 48, 510)
    ctx.quadraticCurveTo(80, 502, 96, 511)

    ctx.moveTo(122, 522)
    ctx.quadraticCurveTo(182, 529, 205, 544)
    ctx.quadraticCurveTo(248, 574, 289, 556)
    ctx.quadraticCurveTo(308, 545, 347, 547)
    ctx.quadraticCurveTo(383, 552, 399, 545)
    ctx.quadraticCurveTo(412, 544, 423, 533)
    // ctx.quadraticCurveTo()
    // ctx.quadraticCurveTo()
    // ctx.moveTo()
    // ctx.quadraticCurveTo()
    ctx.stroke()
    ctx.closePath()
  }

  // 樹脂底
  const resinSoleEvaWhiteCleats = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    // グレーのソール
    ctx.beginPath()
    ctx.fillStyle = '#bfbfbf'
    ctx.strokeStyle = '#383838'
    ctx.lineWidth = 1.0
    ctx.moveTo(0, 505) // 左上
    ctx.quadraticCurveTo(0, 515, 0, 513) //
    ctx.quadraticCurveTo(70, 510, 123, 520) //
    ctx.quadraticCurveTo(205, 528, 234, 550) //
    ctx.quadraticCurveTo(380, 575, 428, 505) //
    ctx.quadraticCurveTo(376, 530, 251, 523) //
    ctx.quadraticCurveTo(129, 499, 0, 505) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.beginPath()
    ctx.fillStyle = '#bfbfbf'
    ctx.strokeStyle = '#383838'
    ctx.lineWidth = 1.0
    ctx.moveTo(232, 549) // 左上
    ctx.quadraticCurveTo(238, 562, 238, 562) // 左下
    ctx.quadraticCurveTo(261, 567, 270, 562) //
    ctx.quadraticCurveTo(274, 556, 274, 556) //
    // ctx.quadraticCurveTo(232, 549, 232, 549) //
    // ctx.quadraticCurveTo() //
    ctx.stroke()
    ctx.fill()
    ctx.moveTo(235, 539)
    ctx.quadraticCurveTo(255, 550, 275, 552)
    ctx.stroke()
    ctx.closePath()

    ctx.beginPath()
    ctx.fillStyle = '#44463F'
    ctx.strokeStyle = '#383838'
    ctx.lineWidth = 1.0
    ctx.moveTo(241, 563) // 左上
    ctx.quadraticCurveTo(242, 582, 242, 582) // 左下
    ctx.quadraticCurveTo(248, 587, 252, 582) // 左の内側
    ctx.quadraticCurveTo(255, 576, 259, 582) // 右の内側
    ctx.quadraticCurveTo(263, 587, 267, 582) // 右下

    ctx.quadraticCurveTo(268, 563, 268, 563) //
    ctx.quadraticCurveTo(241, 563, 241, 563) //
    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //
    ctx.stroke()
    ctx.fill()
    ctx.closePath()

    // ctx.beginPath()
    // ctx.fillStyle = 'gray'
    // ctx.strokeStyle = '#383838'
    // ctx.lineWidth = 1.0
    // ctx.moveTo(0, 505) // 左上
    // // ctx.quadraticCurveTo() //
    // ctx.fill()
    // ctx.stroke()
    // ctx.closePath()

    // midsole
    ctx.beginPath()
    ctx.fillStyle = '#fff'
    ctx.strokeStyle = '#383838'
    ctx.lineWidth = 1.0
    ctx.moveTo(5, 503) // 左上
    ctx.quadraticCurveTo(153, 508, 260, 535) //
    // ctx.quadraticCurveTo() //
    ctx.quadraticCurveTo(445, 543, 430, 485) // かかと右上
    ctx.quadraticCurveTo(424, 530, 243, 515) //
    ctx.quadraticCurveTo(126, 485, 5, 503) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // ctx.beginPath()
    // ctx.fillStyle = '#fff'
    // ctx.strokeStyle = '#383838'
    // ctx.lineWidth = 1.0
    // ctx.moveTo(0, 525) // 左上
    // // ctx.quadraticCurveTo() // ソール中間_左
    // // ctx.quadraticCurveTo() // ソール中間_左
    // // ctx.quadraticCurveTo() // ソール中間_左
    // ctx.stroke()
    // ctx.closePath()
  }

  // 革底
  const leatherSoleWithEva = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    // 歯の描画_1
    ctx.beginPath()
    ctx.fillStyle = '#44463F'
    ctx.strokeStyle = '#383838'
    ctx.lineWidth = 1.0
    ctx.moveTo(187, 534) // 左上
    ctx.quadraticCurveTo(185, 564, 185, 564)
    ctx.quadraticCurveTo(194, 565, 204, 556)
    ctx.quadraticCurveTo(205, 536, 205, 536)
    ctx.quadraticCurveTo(187, 534, 187, 534)
    // ctx.quadraticCurveTo()
    ctx.fill()

    ctx.moveTo(194, 537)
    ctx.quadraticCurveTo(193, 556, 193, 556)
    ctx.stroke()
    ctx.closePath()

    // 歯の描画_2
    ctx.beginPath()
    ctx.fillStyle = '#44463F'
    ctx.strokeStyle = '#383838'
    ctx.lineWidth = 1.0
    ctx.moveTo(340, 542) // 左上
    ctx.quadraticCurveTo(342, 565, 342, 565)
    ctx.quadraticCurveTo(360, 565, 376, 555)
    ctx.quadraticCurveTo(378, 535, 378, 535)
    ctx.quadraticCurveTo(340, 542, 340, 542)
    // ctx.quadraticCurveTo()
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // 革底
    ctx.beginPath()
    ctx.fillStyle = 'gray'
    ctx.strokeStyle = '#383838'
    ctx.lineWidth = 1.0
    ctx.moveTo(0, 492) // 左上
    ctx.quadraticCurveTo(0, 510, 0, 510)
    ctx.quadraticCurveTo(120, 522, 120, 522)
    ctx.quadraticCurveTo(355, 570, 427, 512)
    ctx.quadraticCurveTo(440, 498, 430, 490)
    ctx.quadraticCurveTo(375, 545, 122, 505)
    ctx.quadraticCurveTo(0, 492, 0, 492)
    // ctx.quadraticCurveTo()
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.beginPath()
    ctx.setLineDash([10, 10])
    ctx.strokeStyle = '#383838'
    ctx.lineWidth = 2.2
    ctx.moveTo(4, 494) // 左上
    ctx.quadraticCurveTo(120, 512, 272, 526)
    ctx.quadraticCurveTo(387, 530, 429, 494)
    // ctx.quadraticCurveTo()
    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#383838'

    // 歯の描画_2
    // ctx.beginPath()
    // ctx.fillStyle = '#fff'
    // ctx.strokeStyle = '#383838'
    // ctx.lineWidth = 1.0
    // ctx.moveTo(0, 525) // 左上
    // // ctx.quadraticCurveTo()
    // // ctx.quadraticCurveTo()
    // // ctx.quadraticCurveTo()
    // ctx.stroke()
    // ctx.closePath()
  }

  const midsole = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.beginPath()
    ctx.fillStyle = '#fff'
    ctx.strokeStyle = '#383838'
    ctx.lineWidth = 1.0
    // 半時計回りで描画
    ctx.moveTo(0, 490) // 左上
    ctx.quadraticCurveTo(0, 520, 0, 520) //
    ctx.quadraticCurveTo(109, 500, 135, 525) // かかと入り口
    ctx.quadraticCurveTo(229, 555, 337, 555) // かかと中間
    ctx.quadraticCurveTo(435, 545, 433, 475) // かかと右上
    ctx.quadraticCurveTo(350, 525, 150, 475) // かかと出口
    ctx.quadraticCurveTo(120, 468, 0, 490) //
    // ctx.quadraticCurveTo() //
    ctx.fill()

    // 模様
    ctx.moveTo(0, 500) // 左上
    ctx.quadraticCurveTo(59, 486, 59, 486) //
    ctx.moveTo(107, 487) // 左上
    ctx.quadraticCurveTo(360, 550, 427, 491) //
    ctx.moveTo(77, 490) // 左上
    ctx.quadraticCurveTo(360, 560, 424, 501) //
    ctx.moveTo(127, 510) // 左上
    ctx.quadraticCurveTo(360, 570, 424, 511) //
    // ctx.quadraticCurveTo() //

    // ctx.moveTo(0, 500) // 左上
    // ctx.quadraticCurveTo() //
    ctx.stroke()
    ctx.closePath()
  }
  const runningAndArtificialRubberSole = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.beginPath()
    ctx.fillStyle = 'black'
    ctx.strokeStyle = 'black'
    ctx.lineWidth = 1.0
    ctx.moveTo(0, 520) // 左上
    ctx.quadraticCurveTo(0, 530, 0, 530) //
    ctx.quadraticCurveTo(30, 532, 50, 527)
    ctx.quadraticCurveTo(94, 525, 94, 525) //
    ctx.quadraticCurveTo(153, 540, 153, 540) //
    ctx.quadraticCurveTo(154, 530, 154, 530) //
    ctx.quadraticCurveTo(91, 496, 0, 520) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.beginPath()
    ctx.fillStyle = 'black'
    ctx.strokeStyle = 'black'
    ctx.lineWidth = 1.0
    ctx.moveTo(172, 531) // 左上
    ctx.quadraticCurveTo(171, 543, 171, 543) // 左下
    ctx.quadraticCurveTo(240, 559, 293, 561) // 右下
    ctx.quadraticCurveTo(293, 549, 293, 549) //
    ctx.quadraticCurveTo(229, 544, 172, 531) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.beginPath()
    ctx.fillStyle = 'black'
    ctx.strokeStyle = 'black'
    ctx.lineWidth = 1.0
    ctx.moveTo(311, 550) // 左上
    ctx.quadraticCurveTo(310, 561, 310, 561) // 左下
    ctx.quadraticCurveTo(380, 565, 425, 515) // 右
    ctx.quadraticCurveTo(359, 553, 311, 550) // 左上
    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  // ランニングシューズ底
  const runningShoesSole = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    midsole(ctx, state)
    runningAndArtificialRubberSole(ctx, state)
  }

  // 人工芝底
  const artificialTurfSole = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    midsole(ctx, state)
    runningAndArtificialRubberSole(ctx, state)
    gripWarts(ctx, -20, 45)
    gripWarts(ctx, 0, 45)
    gripWarts(ctx, 20, 43)
    gripWarts(ctx, 40, 40)
    gripWarts(ctx, 60, 40)
    gripWarts(ctx, 80, 45)
    gripWarts(ctx, 104, 51)

    gripWarts(ctx, 150, 62)
    gripWarts(ctx, 170, 66)
    gripWarts(ctx, 190, 69)
    gripWarts(ctx, 210, 72)
    gripWarts(ctx, 230, 74)
    gripWarts(ctx, 250, 76)

    gripWarts(ctx, 290, 76)
    gripWarts(ctx, 310, 75)
    gripWarts(ctx, 330, 71)
    gripWarts(ctx, 350, 63)
    gripWarts(ctx, 370, 51)
    // gripWarts(ctx, 380, 41)
  }

  switch (state.outSole.value) {
    case 'pointSole':
      pointOutSole(ctx, state)
      break
    case 'resinSoleEvaWhiteCleats':
    case 'unselected':
      resinSoleEvaWhiteCleats(ctx, state)
      break
    case 'leatherSoleWithEva':
      leatherSoleWithEva(ctx, state)
      break
    case 'runningShoesSole':
      runningShoesSole(ctx, state)
      break
    case 'artificialTurfSole':
      artificialTurfSole(ctx, state)
      break
    default:
      break
  }
}

// stitchここから
// ctx.beginPath()
// ctx.setLineDash([3, 3])
// ctx.strokeStyle = stitchColor
// ctx.lineWidth = 1.2
// ctx.moveTo(489, 376) //
// ctx.quadraticCurveTo(476, 390, 476, 390)
// ctx.stroke()
// ctx.setLineDash([])
// ctx.closePath()
// ctx.lineWidth = 0.8
// ctx.strokeStyle = '#383838'

// 断面
// ctx.strokeStyle = '#fff'
// ctx.lineWidth = 2.2
// ctx.beginPath()
// ctx.moveTo(121, 504) // 左上
// ctx.quadraticCurveTo(145, 437, 255, 388)
// ctx.quadraticCurveTo(334, 351, 415, 338)
// // ctx.quadraticCurveTo()
// ctx.fill()
// ctx.stroke()
// ctx.closePath()

const healMainParts = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  // 半時計回りで描画
  ctx.fillStyle = state.healReinforcement.color
  ctx.beginPath()
  ctx.moveTo(121, 504) // 左上
  ctx.quadraticCurveTo(198, 528, 303, 531)
  ctx.quadraticCurveTo(429, 527, 430, 489) // ソール右上
  ctx.quadraticCurveTo(450, 398, 415, 338) // かかと右上
  ctx.quadraticCurveTo(328, 355, 245, 394) // 左上の辺＿中間
  ctx.quadraticCurveTo(145, 442, 121, 504)

  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = '#fff'
  ctx.lineWidth = 2.2
  ctx.beginPath()
  ctx.moveTo(121, 504) // 左上
  ctx.quadraticCurveTo(145, 437, 255, 388)
  ctx.quadraticCurveTo(334, 351, 415, 338)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.5
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.strokeStyle = state.stitch.color
  ctx.lineWidth = 1.2
  // 外側
  ctx.moveTo(124, 504) //
  ctx.quadraticCurveTo(147, 440, 255, 392)
  ctx.quadraticCurveTo(336, 353, 415, 342)

  // 内側
  ctx.moveTo(128, 504) //
  ctx.quadraticCurveTo(149, 445, 255, 397)
  ctx.quadraticCurveTo(336, 357, 415, 346)

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#383838'
}

const healDecoration = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const healDecorationForQuarterCut = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.healDecoration.color
    // 半時計回りで描画
    ctx.beginPath()
    ctx.moveTo(415, 338) // 右下
    ctx.quadraticCurveTo(419, 320, 406, 286)
    ctx.quadraticCurveTo(403, 257, 397, 247)
    ctx.quadraticCurveTo(394, 240, 383, 240) // 頂点
    ctx.quadraticCurveTo(364, 240, 349, 252)
    ctx.quadraticCurveTo(337, 265, 322, 285)
    ctx.quadraticCurveTo(295, 315, 253, 301) // 左上
    ctx.quadraticCurveTo(245, 302, 252, 323)
    ctx.quadraticCurveTo(256, 335, 276, 338)
    ctx.quadraticCurveTo(304, 342, 357, 337)
    ctx.quadraticCurveTo(382, 334, 392, 345)
    ctx.quadraticCurveTo(415, 338, 415, 338)
    ctx.stroke()
    ctx.fill()
    ctx.closePath()

    // 断面
    ctx.strokeStyle = '#fff'
    ctx.lineWidth = 2.2
    ctx.beginPath()
    ctx.moveTo(253, 301) // 左上
    ctx.quadraticCurveTo(245, 302, 252, 323)
    ctx.quadraticCurveTo(256, 335, 276, 338)
    ctx.quadraticCurveTo(304, 342, 357, 337)
    ctx.quadraticCurveTo(382, 334, 392, 345)
    ctx.stroke()
    ctx.closePath()

    // stitchここから
    ctx.beginPath()
    ctx.setLineDash([3, 3])
    ctx.strokeStyle = state.stitch.color
    ctx.lineWidth = 1.2
    ctx.moveTo(259, 303) // 左上
    ctx.quadraticCurveTo(249, 300, 255, 319)
    ctx.quadraticCurveTo(259, 332, 279, 333)
    ctx.quadraticCurveTo(307, 338, 360, 332)
    ctx.quadraticCurveTo(384, 332, 395, 341)
    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#383838'
  }

  const healDecorationForLowCut = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.healDecoration.color
    // 半時計回りで描画
    ctx.beginPath()
    ctx.moveTo(307, 296) // 左下
    ctx.quadraticCurveTo(389, 311, 388, 351)
    ctx.quadraticCurveTo(412, 335, 412, 335) // 右下
    ctx.quadraticCurveTo(415, 308, 404, 275) // 右上
    ctx.quadraticCurveTo(378, 296, 350, 276) // 左上1
    ctx.quadraticCurveTo(333, 266, 322, 283) // 左上2
    ctx.quadraticCurveTo(307, 296, 307, 296)
    // ctx.quadraticCurveTo()
    ctx.stroke()
    ctx.fill()
    ctx.closePath()

    // // 断面
    ctx.strokeStyle = '#fff'
    ctx.lineWidth = 2.2
    ctx.beginPath()
    ctx.moveTo(308, 294) // 左上
    ctx.quadraticCurveTo(375, 308, 386, 344)
    ctx.stroke()
    ctx.closePath()

    // stitchここから
    ctx.beginPath()
    ctx.setLineDash([3, 3])
    ctx.strokeStyle = state.stitch.color
    ctx.lineWidth = 1.2
    ctx.moveTo(322, 292) // 左上
    ctx.quadraticCurveTo(379, 305, 392, 339)

    ctx.moveTo(407, 300)
    ctx.quadraticCurveTo(407, 335, 407, 335)
    // ctx.quadraticCurveTo()
    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#383838'
  }

  switch (state.openingPattern.value) {
    case 'quarterCut':
      healDecorationForQuarterCut(ctx, state)
      break
    case 'lowCut':
    case 'mountainMiddleCut':
    case 'horizontalMiddleCut':
    default:
      healDecorationForLowCut(ctx, state)
      break
  }
}

const mainUnit = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  // 本体（ATOMSマークの下）
  const quarterCutMainUnit = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.fillStyle = state.mainUnit.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(0, 504) // 左下
    ctx.quadraticCurveTo(0, 357, 0, 357) // 左上
    ctx.quadraticCurveTo(178, 223, 178, 223) // 右上
    ctx.quadraticCurveTo(183, 252, 201, 271) // 履き口_中間
    ctx.quadraticCurveTo(217, 292, 251, 303) // 右下... かかと飾りと接合
    ctx.quadraticCurveTo(385, 330, 391, 343) // 右下... かかと本体と接合
    ctx.quadraticCurveTo(328, 355, 245, 394) // 左上の辺＿中間
    ctx.quadraticCurveTo(145, 442, 121, 504) // かかと本体左下
    ctx.quadraticCurveTo(27, 509, 0, 504) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // stitchここから
    ctx.beginPath()
    ctx.setLineDash([3, 3])
    ctx.strokeStyle = 'gray' //state.stitch.color
    ctx.lineWidth = 1.2
    ctx.moveTo(119, 288) //
    ctx.quadraticCurveTo(140, 343, 276, 378)
    // ctx.quadraticCurveTo()
    // ctx.quadraticCurveTo()
    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#383838'
  }

  const lowCutMainUnit = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.fillStyle = state.mainUnit.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(0, 504) // 左下
    ctx.quadraticCurveTo(0, 357, 0, 357) // 左上
    ctx.quadraticCurveTo(116, 270, 116, 270) // 右上
    ctx.quadraticCurveTo(137, 240, 190, 279) // 履き口_中間
    ctx.quadraticCurveTo(257, 347, 320, 286) // 右下... かかと飾りと接合
    ctx.quadraticCurveTo(337, 263, 365, 282)
    ctx.quadraticCurveTo(388, 290, 400, 273) //
    ctx.quadraticCurveTo(400, 511, 400, 511) //
    ctx.quadraticCurveTo(0, 504, 0, 504) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // // stitchここから
    // ctx.beginPath()
    // ctx.setLineDash([3, 3])
    // ctx.strokeStyle = 'gray' //state.stitch.color
    // ctx.lineWidth = 1.2
    // ctx.moveTo(119, 288) //
    // ctx.quadraticCurveTo(140, 343, 276, 378)
    // // ctx.quadraticCurveTo()
    // // ctx.quadraticCurveTo()
    // ctx.stroke()
    // ctx.setLineDash([])
    // ctx.closePath()
    // ctx.lineWidth = 0.8
    // ctx.strokeStyle = '#383838'
  }

  switch (state.openingPattern.value) {
    case 'lowCut':
    case 'mountainMiddleCut':
    case 'horizontalMiddleCut':
    default:
      lowCutMainUnit(ctx, state)
      break
    case 'quarterCut':
      quarterCutMainUnit(ctx, state)
      break
      break
  }
}

const middleCut = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const mountainMiddleCutParts = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.beginPath()
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.middleCutOpening.color
    ctx.moveTo(145, 250)
    ctx.quadraticCurveTo(210, 210, 250, 240)
    ctx.quadraticCurveTo(298, 262, 330, 268) // 左上
    ctx.quadraticCurveTo(390, 277, 400, 259) // 右上
    ctx.quadraticCurveTo(402, 278, 402, 278)
    ctx.quadraticCurveTo(244, 336, 244, 336)
    ctx.quadraticCurveTo(145, 250, 145, 250)
    // ctx.quadraticCurveTo()
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // stitchここから
    ctx.beginPath()
    ctx.setLineDash([3, 3])
    ctx.strokeStyle = state.stitch.color
    ctx.lineWidth = 1.2
    ctx.moveTo(178, 271) //
    ctx.quadraticCurveTo(207, 247, 251, 263)
    ctx.quadraticCurveTo(287, 288, 322, 285)
    // ctx.quadraticCurveTo()
    // ctx.quadraticCurveTo()
    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#383838'
  }

  const horizontalMiddleCutParts = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.beginPath()
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.middleCutOpening.color
    ctx.moveTo(138, 245)
    ctx.quadraticCurveTo(165, 236, 333, 265) // かかと左
    ctx.quadraticCurveTo(378, 277, 403, 268) // かかと右
    ctx.quadraticCurveTo(403, 278, 403, 278) // かかと右下
    ctx.quadraticCurveTo(256, 330, 256, 330)
    ctx.quadraticCurveTo(138, 245, 138, 245)
    // ctx.quadraticCurveTo()
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // // stitchここから
    // ctx.beginPath()
    // ctx.setLineDash([3, 3])
    // ctx.strokeStyle = state.stitch.color
    // ctx.lineWidth = 1.2
    // ctx.moveTo(178, 271) //
    // // ctx.quadraticCurveTo()
    // // ctx.quadraticCurveTo()
    // ctx.stroke()
    // ctx.setLineDash([])
    // ctx.closePath()
    // ctx.lineWidth = 0.8
    // ctx.strokeStyle = '#383838'
  }

  switch (state.openingPattern.value) {
    case 'mountainMiddleCut':
      mountainMiddleCutParts(ctx, state)
      break
    case 'horizontalMiddleCut':
      horizontalMiddleCutParts(ctx, state)
      break
    default:
      break
  }
}

// 側面＿ATOMSマーク
const atomsDesign = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#383838'

  // 下地 / line2.color
  // 時計回り
  ctx.fillStyle = state.lineType.value === 'doubleLine' ? state.line2.color : state.line.color
  ctx.beginPath()
  ctx.moveTo(0, 359) // 左上
  ctx.quadraticCurveTo(18, 345, 18, 345) //右上
  ctx.quadraticCurveTo(54, 371, 54, 371) // デザイン交差_右下＿左
  ctx.quadraticCurveTo(65, 347, 94, 311) //
  ctx.quadraticCurveTo(110, 284, 110, 284) //
  ctx.quadraticCurveTo(122, 281, 122, 281) // 右上＿右上
  ctx.quadraticCurveTo(110, 310, 95, 329) // 中間
  ctx.quadraticCurveTo(79, 352, 70, 377) // デザイン交差_右下＿右
  ctx.quadraticCurveTo(97, 395, 123, 405) // 右下_左
  ctx.quadraticCurveTo(152, 332, 152, 332) //　右下＿右上頂点
  ctx.quadraticCurveTo(161, 356, 157, 427) //
  ctx.quadraticCurveTo(109, 469, 109, 469) // 右下
  ctx.quadraticCurveTo(42, 433, 42, 433) // 右下＿左上＿下
  ctx.quadraticCurveTo(25, 466, 23, 502) // 左下_右
  ctx.quadraticCurveTo(0, 504, 0, 504) // 左下
  ctx.quadraticCurveTo(0, 459, 0, 459) // 左下＿左上
  ctx.quadraticCurveTo(9, 439, 25, 415) //
  ctx.quadraticCurveTo(0, 395, 0, 395) // 左上＿左
  ctx.quadraticCurveTo(0, 359, 0, 359) //
  // ctx.quadraticCurveTo() //
  // ctx.quadraticCurveTo() //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.fillStyle = state.line.color
  ctx.strokeStyle = '#bbb'
  // 時計回り
  ctx.beginPath()
  ctx.moveTo(0, 359) // 左上
  ctx.quadraticCurveTo(18, 348, 18, 348) //
  ctx.quadraticCurveTo(30, 362, 51, 374) //
  ctx.quadraticCurveTo(65, 347, 94, 311) //
  ctx.quadraticCurveTo(107, 279, 122, 283) // 右上＿右上
  ctx.quadraticCurveTo(115, 284, 110, 298) //
  ctx.quadraticCurveTo(103, 311, 94, 319) //
  ctx.quadraticCurveTo(77, 344, 63, 374) //
  ctx.quadraticCurveTo(60, 381, 66, 383) // デザイン交差_右下＿右
  ctx.quadraticCurveTo(91, 399, 121, 410) //
  ctx.quadraticCurveTo(150, 346, 150, 346) // 右上＿右上
  ctx.quadraticCurveTo(153, 369, 150, 421) //
  ctx.quadraticCurveTo(153, 425, 147, 430) //
  ctx.quadraticCurveTo(106, 465, 106, 465) // 右下_左下
  ctx.quadraticCurveTo(62, 442, 38, 425) //
  ctx.quadraticCurveTo(19, 454, 18, 503) // 左下_右
  ctx.quadraticCurveTo(0, 504, 0, 504) // 左下_左
  ctx.quadraticCurveTo(0, 466, 0, 466) //
  ctx.quadraticCurveTo(12, 435, 26, 413) //
  ctx.quadraticCurveTo(0, 392, 0, 392) //
  ctx.quadraticCurveTo(0, 359, 0, 359) //
  // ctx.quadraticCurveTo() //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  const onStitchColor = darkenColor(state.line.color, 0.3)
  ctx.lineWidth = 1.2
  ctx.strokeStyle = onStitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(20, 358) //
  ctx.quadraticCurveTo(52, 382, 52, 382)
  ctx.quadraticCurveTo(65, 348, 90, 321)
  ctx.quadraticCurveTo(58, 372, 58, 384)
  ctx.quadraticCurveTo(122, 416, 122, 416)
  ctx.quadraticCurveTo(148, 357, 148, 357)
  ctx.quadraticCurveTo(146, 427, 146, 427)
  ctx.quadraticCurveTo(105, 460, 105, 460)
  ctx.quadraticCurveTo(36, 421, 36, 421)
  ctx.quadraticCurveTo(14, 460, 15, 499)

  ctx.moveTo(2, 468)
  ctx.quadraticCurveTo(10, 446, 32, 411)
  ctx.quadraticCurveTo(1, 388, 1, 388)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
}

const vampStrapReinforcement = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  // 紐下の補強
  const laceVampStrapReinforcementForQuarterCut = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.fillStyle = state.vampStrapReinforcement.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(0, 359) // 左下
    ctx.quadraticCurveTo(0, 343, 0, 343) // 左上
    ctx.quadraticCurveTo(42, 323, 74, 296) // 中間
    ctx.quadraticCurveTo(97, 285, 127, 248) // 中間2
    ctx.quadraticCurveTo(140, 228, 157, 214) //
    ctx.quadraticCurveTo(176, 192, 181, 212) // 右上＿右下
    ctx.quadraticCurveTo(183, 252, 144, 270) //
    ctx.quadraticCurveTo(122, 284, 122, 284) //
    ctx.quadraticCurveTo(108, 285, 105, 301) //
    ctx.quadraticCurveTo(97, 313, 81, 321) //
    ctx.quadraticCurveTo(34, 347, 34, 347) //
    ctx.quadraticCurveTo(22, 352, 18, 349) //
    ctx.quadraticCurveTo(10, 357, 0, 359) //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // 革の断面
    ctx.lineWidth = 2.2
    ctx.strokeStyle = 'white'
    ctx.beginPath()
    ctx.moveTo(180, 212) // 左下
    ctx.quadraticCurveTo(183, 252, 144, 268) //
    ctx.quadraticCurveTo(122, 284, 122, 282) //
    ctx.quadraticCurveTo(108, 285, 105, 299) //
    ctx.quadraticCurveTo(97, 313, 81, 319) //
    ctx.quadraticCurveTo(34, 347, 34, 345) //
    ctx.quadraticCurveTo(22, 352, 18, 347) //
    ctx.quadraticCurveTo(10, 357, 0, 357) //
    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //

    ctx.stroke()
    ctx.closePath()

    // stitchここから
    ctx.beginPath()
    ctx.setLineDash([3, 3])
    ctx.strokeStyle = state.stitch.color
    ctx.lineWidth = 1.2
    ctx.moveTo(1, 361) //
    ctx.quadraticCurveTo(12, 362, 19, 352)
    ctx.quadraticCurveTo(38, 350, 84, 321)
    ctx.quadraticCurveTo(102, 314, 110, 295)
    ctx.quadraticCurveTo(109, 290, 114, 288)

    ctx.moveTo(11, 338) //
    ctx.quadraticCurveTo(74, 298, 74, 298)
    ctx.quadraticCurveTo(110, 275, 131, 247)
    ctx.quadraticCurveTo(138, 234, 167, 208)
    ctx.quadraticCurveTo(173, 202, 177, 212)
    ctx.quadraticCurveTo(180, 244, 153, 260)
    ctx.quadraticCurveTo(123, 279, 123, 279)
    ctx.quadraticCurveTo(107, 284, 104, 297)
    ctx.quadraticCurveTo(98, 308, 87, 313)
    ctx.quadraticCurveTo(27, 345, 27, 345)
    ctx.quadraticCurveTo(17, 344, 17, 344)
    ctx.quadraticCurveTo(11, 352, 0, 354)
    // ctx.quadraticCurveTo()
    // ctx.quadraticCurveTo(0, 354, 0, 354)
    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#383838'
  }

  const laceVampStrapReinforcementForLowCut = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.fillStyle = state.vampStrapReinforcement.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(0, 359) // 左下
    ctx.quadraticCurveTo(0, 343, 0, 343) // 左上
    ctx.quadraticCurveTo(42, 319, 74, 292) // 中間
    ctx.quadraticCurveTo(97, 282, 127, 250) // 中間2
    ctx.quadraticCurveTo(150, 239, 185, 274) // 右下_上
    ctx.quadraticCurveTo(185, 285, 175, 290) // 右下_下
    ctx.quadraticCurveTo(115, 300, 0, 359) //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // // 革の断面
    ctx.lineWidth = 2.2
    ctx.strokeStyle = 'white'
    ctx.beginPath()
    ctx.moveTo(129, 246) //
    ctx.quadraticCurveTo(154, 244, 181, 271) //
    ctx.quadraticCurveTo(190, 283, 173, 290) //
    ctx.quadraticCurveTo(95, 304, 0, 360) //
    // ctx.quadraticCurveTo() //

    ctx.stroke()
    ctx.closePath()

    // // stitchここから
    ctx.beginPath()
    ctx.setLineDash([3, 3])
    ctx.strokeStyle = state.stitch.color
    ctx.lineWidth = 1.2
    ctx.moveTo(1, 355) //
    ctx.quadraticCurveTo(97, 300, 173, 284)
    ctx.quadraticCurveTo(187, 281, 172, 271)
    ctx.quadraticCurveTo(157, 254, 131, 252)
    ctx.quadraticCurveTo(111, 277, 77, 295)
    ctx.quadraticCurveTo(40, 326, 2, 344)
    // ctx.quadraticCurveTo()
    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#383838'
  }

  switch (state.openingPattern.value) {
    case 'quarterCut':
      laceVampStrapReinforcementForQuarterCut(ctx, state)
      break
    case 'lowCut':
    case 'mountainMiddleCut':
    case 'horizontalMiddleCut':
    default:
      laceVampStrapReinforcementForLowCut(ctx, state)
      break
  }
}

const tongue = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  if (state.tongue.value === 'foldingTongue') return
  // ベロ表
  const tongueFront = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.fillStyle = state.tongueFront.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(186 + x, 227 + y) // 左下
    ctx.quadraticCurveTo(193 + x, 252 + y, 217 + x, 279 + y) //
    ctx.quadraticCurveTo(238 + x, 294 + y, 259 + x, 289 + y) //
    ctx.quadraticCurveTo(278 + x, 281 + y, 283 + x, 261 + y) // 右下
    ctx.quadraticCurveTo(273 + x, 226 + y, 256 + x, 202 + y) //
    ctx.quadraticCurveTo(239 + x, 181 + y, 256 + x, 173 + y) //
    ctx.quadraticCurveTo(242 + x, 174 + y, 221 + x, 195 + y) //
    ctx.quadraticCurveTo(197 + x, 210 + y, 186 + x, 227 + y) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  // ベロ裏
  const tongueLinings1ForQuarterCut = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.fillStyle = state.tongueLinings.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(174, 204) // 左上
    ctx.quadraticCurveTo(177, 289, 247, 301) // 履き口中間
    ctx.quadraticCurveTo(292, 325, 322, 293) //
    ctx.quadraticCurveTo(394, 243, 394, 243) // 右上 // ここまで下段
    ctx.quadraticCurveTo(388, 231, 373, 233) // ここから上段折り返し
    ctx.quadraticCurveTo(336, 238, 321, 273) //
    ctx.quadraticCurveTo(308, 311, 255, 297) //
    ctx.quadraticCurveTo(214, 284, 201, 258) //
    ctx.quadraticCurveTo(189, 241, 187, 226) //
    ctx.quadraticCurveTo(184, 202, 177, 205) //
    ctx.quadraticCurveTo(174, 204, 174, 204) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  // ベロ裏
  const tongueLinings2 = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.fillStyle = state.tongueLinings.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(228 + x, 285 + y) // 左上
    ctx.quadraticCurveTo(248 + x, 182 + y, 248 + x, 182 + y) //
    ctx.quadraticCurveTo(249 + x, 174 + y, 259 + x, 172 + y) // 頂点
    ctx.quadraticCurveTo(266 + x, 166 + y, 281 + x, 177 + y) //
    ctx.quadraticCurveTo(324 + x, 201 + y, 354 + x, 237 + y) // 右下
    ctx.quadraticCurveTo(310 + x, 310 + y, 310 + x, 310 + y) //
    ctx.quadraticCurveTo(248 + x, 310 + y, 228 + x, 285 + y) //
    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // 影の描画
    const coordinates = { x0: 124 + x, y0: 160 + y, x1: 440 + x, y1: 300 + y }
    const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
    ctx.fillStyle = gradient

    ctx.beginPath()
    ctx.moveTo(229 + x, 285 + y) // 左上
    ctx.quadraticCurveTo(280 + x, 314 + y, 288 + x, 256 + y) //
    ctx.quadraticCurveTo(287 + x, 226 + y, 267 + x, 200 + y) //
    ctx.quadraticCurveTo(257 + x, 178 + y, 287 + x, 199 + y) //
    ctx.quadraticCurveTo(313 + x, 243 + y, 352 + x, 240 + y) //
    ctx.quadraticCurveTo(306 + x, 346 + y, 229 + x, 285 + y) //
    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //
    ctx.stroke()
    ctx.fill()
    ctx.closePath()
  }

  const quarterCutTongue = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    tongueLinings2(ctx, state) // ベロ裏
    tongueFront(ctx, state) // ベロ表
    tongueLinings1ForQuarterCut(ctx, state) // ベロ裏
  }

  // ベロ裏
  const tongueLinings1ForLowCut = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.fillStyle = state.tongueLinings.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(132 + x, 246 + y) // 左上
    ctx.quadraticCurveTo(242, 328, 242, 328) // 中間真下
    ctx.quadraticCurveTo(338, 280, 338, 280) //
    ctx.quadraticCurveTo(379, 295, 379, 295) //
    ctx.quadraticCurveTo(404, 276, 404, 276) // 踵右下
    ctx.quadraticCurveTo(387, 249, 380, 281) //
    ctx.quadraticCurveTo(326, 254, 320, 275) // かかと左
    ctx.quadraticCurveTo(252, 341, 182, 263) //
    ctx.quadraticCurveTo(143, 233, 131, 246) //
    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const tongueLinings1ForMiddleCut = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.fillStyle = state.tongueLinings.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.tongueLinings.color
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(145, 253) // 左上
    ctx.quadraticCurveTo(210, 213, 250, 243)
    ctx.quadraticCurveTo(370, 290, 398, 263) // かかと右下
    ctx.quadraticCurveTo(400, 257, 400, 256) // かかと右上
    ctx.quadraticCurveTo(350, 282, 229, 225) //
    ctx.quadraticCurveTo(192, 213, 142, 245) //
    ctx.quadraticCurveTo(145, 253, 145, 253)
    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const tongueLiningsBackForMiddleCut = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    const coordinates = { x0: 150, y0: 300, x1: 700, y1: 400 }
    const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
    ctx.fillStyle = gradient

    ctx.beginPath()
    ctx.moveTo(256, 238) // 左上
    ctx.quadraticCurveTo(299, 224, 299, 224)
    ctx.quadraticCurveTo(318, 214, 339, 227) //
    ctx.quadraticCurveTo(362, 248, 398, 256) //
    ctx.quadraticCurveTo(384, 285, 384, 285) //
    ctx.quadraticCurveTo(256, 238, 256, 238) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const tongueLiningsBackForHorizontalMiddleCut = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    const coordinates = { x0: 150, y0: 300, x1: 700, y1: 400 }
    const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
    ctx.fillStyle = gradient

    ctx.beginPath()
    ctx.moveTo(262, 253) // 左上
    ctx.quadraticCurveTo(288, 234, 402, 266) // かかと右
    ctx.quadraticCurveTo(403, 296, 403, 296) //
    ctx.quadraticCurveTo(262, 253, 262, 253) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const tongueLinings1ForHorizontalMiddleCut = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.fillStyle = state.tongueLinings.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.tongueLinings.color
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(138, 247)
    ctx.quadraticCurveTo(165, 238, 333, 267) // かかと左
    ctx.quadraticCurveTo(378, 279, 403, 270) // かかと右
    ctx.quadraticCurveTo(403, 267, 403, 267) //
    ctx.quadraticCurveTo(333, 262, 333, 260) //
    ctx.quadraticCurveTo(183, 228, 143, 242) //
    // ctx.quadraticCurveTo(144, 247, 144, 247) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const lowCutStandingTongue = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    tongueLinings2(ctx, state, -50, 30) // ベロ裏
    tongueFront(ctx, state, -50, 30) // ベロ表
    tongueLinings1ForLowCut(ctx, state) // ベロ裏
  }

  const mountainMiddleCutTongue = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    tongueLinings2(ctx, state, -50, 30) // ベロ裏
    tongueFront(ctx, state, -50, 30) // ベロ表
    tongueLiningsBackForMiddleCut(ctx, state) // ベロ裏
    tongueLinings1ForMiddleCut(ctx, state) // ベロ裏
  }

  const horizontalMiddleCutTongue = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    tongueLinings2(ctx, state, -50, 30) // ベロ裏
    tongueFront(ctx, state, -50, 30) // ベロ表
    tongueLiningsBackForHorizontalMiddleCut(ctx, state) // ベロ裏
    tongueLinings1ForHorizontalMiddleCut(ctx, state) // ベロ裏
  }

  switch (state.openingPattern.value) {
    case 'quarterCut':
      quarterCutTongue(ctx, state)
      break
    case 'lowCut':
    default:
      lowCutStandingTongue(ctx, state)

      break
    case 'mountainMiddleCut':
      mountainMiddleCutTongue(ctx, state)
      break
    case 'horizontalMiddleCut':
      horizontalMiddleCutTongue(ctx, state)
      break
  }
}

const foldingTongue = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  if (state.tongue.value !== 'foldingTongue') return

  const tongueLinings2 = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'

    // 影の描画
    ctx.fillStyle = state.tongueFront.color

    ctx.strokeStyle = '#383838'
    ctx.beginPath()
    ctx.moveTo(158, 255) // 左上
    ctx.quadraticCurveTo(198, 242, 236, 261) //
    ctx.quadraticCurveTo(226, 299, 224, 302) //
    ctx.quadraticCurveTo(187, 278, 158, 255) //

    ctx.stroke()
    ctx.fill()
    ctx.closePath()
  }

  const tongueFront = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.beginPath()
    ctx.fillStyle = state.tongueFront.color
    ctx.strokeStyle = '#383838'
    ctx.moveTo(56, 319) // 左下
    ctx.quadraticCurveTo(124, 298, 138, 265)
    ctx.quadraticCurveTo(145, 253, 157, 257)
    ctx.quadraticCurveTo(183, 281, 227, 305)
    ctx.quadraticCurveTo(242, 259, 242, 259)
    ctx.quadraticCurveTo(234, 238, 234, 238)
    ctx.quadraticCurveTo(174, 180, 60, 293)
    ctx.quadraticCurveTo(46, 310, 56, 319)
    // ctx.quadraticCurveTo()
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // stitchここから
    ctx.beginPath()
    ctx.setLineDash([3, 3])
    ctx.strokeStyle = state.stitch.color
    ctx.lineWidth = 1.2
    ctx.moveTo(65, 294) //
    ctx.quadraticCurveTo(45, 313, 68, 311)
    ctx.quadraticCurveTo(114, 289, 114, 287)
    ctx.quadraticCurveTo(126, 282, 137, 262)
    ctx.quadraticCurveTo(151, 249, 159, 255)

    ctx.moveTo(68, 294) //
    ctx.quadraticCurveTo(50, 310, 68, 306)
    ctx.quadraticCurveTo(114, 286, 114, 281)
    ctx.quadraticCurveTo(123, 280, 135, 260)
    ctx.quadraticCurveTo(151, 245, 159, 255)

    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //

    // ctx.quadraticCurveTo()
    // ctx.quadraticCurveTo()
    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#383838'
  }

  tongueFront(ctx, state) // ベロ表
  tongueLinings2(ctx, state) // ベロ裏

  const tongueLiningsBackForLowCut = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    const coordinates = { x0: 124 + x, y0: 160 + y, x1: 440 + x, y1: 300 + y }
    const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
    ctx.fillStyle = gradient

    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(239, 255) // 左上
    ctx.quadraticCurveTo(225, 304, 225, 304) // 左下
    ctx.quadraticCurveTo(283, 320, 325, 272)
    ctx.quadraticCurveTo(320, 340, 239, 255) //
    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //
    ctx.stroke()
    ctx.fill()
    ctx.closePath()
  }

  const tongueLinings1ForLowCut = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.fillStyle = state.tongueLinings.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(152, 257) // 左上
    // ctx.quadraticCurveTo(242, 328, 242, 310) // 中間真下
    // ctx.quadraticCurveTo(338, 330, 338, 282) //
    ctx.quadraticCurveTo(266, 364, 325, 280) //
    ctx.quadraticCurveTo(379, 295, 379, 295) //
    ctx.quadraticCurveTo(404, 282, 404, 273) // 踵右下
    ctx.quadraticCurveTo(397, 255, 380, 281) //
    ctx.quadraticCurveTo(326, 254, 320, 278) // かかと左
    ctx.quadraticCurveTo(252, 341, 177, 268) //
    ctx.quadraticCurveTo(156, 253, 152, 257) //
    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }
  if (state.openingPattern.value === 'lowCut') {
    tongueLiningsBackForLowCut(ctx, state) // ベロ裏
    tongueLinings1ForLowCut(ctx, state) // ベロ裏
  }

  const tongueLiningsBackForHorizontalMiddleCut = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    const coordinates = { x0: 150, y0: 300, x1: 700, y1: 400 }
    const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
    ctx.fillStyle = gradient

    ctx.beginPath()
    ctx.moveTo(262, 253) // 左上
    ctx.quadraticCurveTo(288, 234, 402, 266) // かかと右
    ctx.quadraticCurveTo(403, 296, 403, 296) //
    ctx.quadraticCurveTo(262, 253, 262, 253) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const tongueLinings1ForHorizontalMiddleCut = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.fillStyle = state.tongueLinings.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.tongueLinings.color
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(138, 247)
    ctx.quadraticCurveTo(165, 238, 333, 267) // かかと左
    ctx.quadraticCurveTo(378, 279, 403, 270) // かかと右
    ctx.quadraticCurveTo(403, 267, 403, 267) //
    ctx.quadraticCurveTo(333, 262, 333, 260) //
    ctx.quadraticCurveTo(183, 228, 143, 242) //
    // ctx.quadraticCurveTo(144, 247, 144, 247) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const tongueLinings1ForMiddleCut = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.fillStyle = state.tongueLinings.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.tongueLinings.color
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(145, 253) // 左上
    ctx.quadraticCurveTo(210, 213, 250, 243)
    ctx.quadraticCurveTo(370, 290, 398, 263) // かかと右下
    ctx.quadraticCurveTo(400, 257, 400, 256) // かかと右上
    ctx.quadraticCurveTo(350, 282, 229, 225) //
    ctx.quadraticCurveTo(192, 213, 142, 245) //
    ctx.quadraticCurveTo(145, 253, 145, 253)
    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const tongueLiningsBackForMiddleCut = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    const coordinates = { x0: 150, y0: 300, x1: 700, y1: 400 }
    const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
    ctx.fillStyle = gradient

    ctx.beginPath()
    ctx.moveTo(256, 238) // 左上
    ctx.quadraticCurveTo(299, 224, 299, 224)
    ctx.quadraticCurveTo(318, 214, 339, 227) //
    ctx.quadraticCurveTo(362, 248, 398, 256) //
    ctx.quadraticCurveTo(384, 285, 384, 285) //
    ctx.quadraticCurveTo(256, 238, 256, 238) //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const mountainMiddleCutTongue = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    tongueLinings2(ctx, state, -50, 30) // ベロ裏
    tongueFront(ctx, state, -50, 30) // ベロ表
    tongueLiningsBackForMiddleCut(ctx, state) // ベロ裏
    tongueLinings1ForMiddleCut(ctx, state) // ベロ裏
  }

  const horizontalMiddleCutTongue = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    // tongueLinings2(ctx, state, -50, 30) // ベロ裏
    tongueFront(ctx, state, -50, 30) // ベロ表
    tongueLiningsBackForHorizontalMiddleCut(ctx, state) // ベロ裏
    tongueLinings1ForHorizontalMiddleCut(ctx, state) // ベロ裏
  }

  switch (state.openingPattern.value) {
    case 'mountainMiddleCut':
      mountainMiddleCutTongue(ctx, state)
      // ctx.beginPath()
      // ctx.fillStyle = 'white'
      // ctx.moveTo(262, 253) // 左上
      // ctx.quadraticCurveTo(288, 234, 402, 266) // かかと右
      // ctx.fill()
      // ctx.closePath()
      ctx.beginPath()
      ctx.fillStyle = state.middleCutOpening.color
      ctx.strokeStyle = '#383838'
      ctx.moveTo(140, 248) // 左上
      ctx.quadraticCurveTo(227, 309, 227, 306)
      ctx.quadraticCurveTo(262, 322, 294, 307)
      ctx.quadraticCurveTo(310, 299, 304, 299)
      ctx.quadraticCurveTo(405, 295, 402, 269) // かかと右
      ctx.quadraticCurveTo(400, 257, 400, 257)
      ctx.quadraticCurveTo(379, 275, 339, 270)
      ctx.quadraticCurveTo(290, 260, 245, 238)
      // ctx.quadraticCurveTo()
      ctx.quadraticCurveTo(210, 216, 140, 248)
      // ctx.quadraticCurveTo()
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      // stitchここから
      ctx.beginPath()
      ctx.setLineDash([3, 3])
      ctx.strokeStyle = state.stitch.color
      ctx.lineWidth = 1.2
      ctx.moveTo(177, 270) //
      ctx.quadraticCurveTo(212, 245, 253, 272)
      ctx.quadraticCurveTo(284, 290, 313, 288)
      // ctx.quadraticCurveTo()
      ctx.stroke()
      ctx.setLineDash([])
      ctx.closePath()
      ctx.lineWidth = 0.8
      ctx.strokeStyle = '#383838'

      break
    case 'horizontalMiddleCut':
      horizontalMiddleCutTongue(ctx, state)
      ctx.beginPath()
      ctx.fillStyle = state.middleCutOpening.color
      ctx.strokeStyle = '#383838'
      ctx.moveTo(140, 248) // 左上
      ctx.quadraticCurveTo(227, 309, 227, 306)
      ctx.quadraticCurveTo(262, 322, 294, 307)
      ctx.quadraticCurveTo(310, 299, 304, 299)
      ctx.quadraticCurveTo(405, 295, 402, 269) // かかと右
      ctx.quadraticCurveTo(339, 268, 339, 268)
      ctx.quadraticCurveTo(217, 248, 217, 248)
      ctx.quadraticCurveTo(153, 239, 140, 248)
      // ctx.quadraticCurveTo()
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      break
  }
}

const vampStraps = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const vampStrapLace = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.fillStyle = state.vampStrap.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(46 + x, 326 + y) // 左上
    ctx.quadraticCurveTo(38 + x, 304 + y, 68 + x, 301 + y) //
    ctx.quadraticCurveTo(54 + x, 326 + y, 46 + x, 326 + y) //
    ctx.stroke()
    ctx.fill()
    ctx.closePath()

    ctx.fillStyle = 'gray'
    ctx.beginPath()
    ctx.moveTo(67 + x, 305 + y) // 左上
    ctx.quadraticCurveTo(52 + x, 309 + y, 58 + x, 317 + y) //
    ctx.quadraticCurveTo(67 + x, 305 + y, 67 + x, 305 + y) //
    ctx.stroke()
    ctx.fill()
    ctx.closePath()
  }
  const beltSameDirection = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {}
  const beltReverseDirection = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {}

  switch (state.vampStrapType.value) {
    case 'laceType':
    default:
      vampStrapLace(ctx, state, -55, 30) // 紐
      vampStrapLace(ctx, state, -27, 17) // 紐
      vampStrapLace(ctx, state) // 紐
      vampStrapLace(ctx, state, 30, -25) // 紐
      vampStrapLace(ctx, state, 55, -50) // 紐
      break
    case 'beltTypeSameDirection':
      beltSameDirection(ctx, state)
      break
    case 'beltTypeReverseDirection':
      beltReverseDirection(ctx, state)
      break
  }
}

const openingPatternReinforcement = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const lowCutReinforcement = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.fillStyle = state.openingReinforcement.color
    ctx.lineWidth = 1.0
    ctx.strokeStyle = '#383838'
    // 時計回り
    ctx.beginPath()
    ctx.moveTo(120, 300) // 左下
    ctx.quadraticCurveTo(220, 388, 383, 340) // 右下
    ctx.quadraticCurveTo(372, 303, 307, 296) // 右上
    ctx.quadraticCurveTo(245, 340, 184, 272) // 左上
    ctx.quadraticCurveTo(120, 300, 120, 300) // 左下
    // ctx.quadraticCurveTo() //
    // ctx.quadraticCurveTo() //
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // // 断面
    ctx.strokeStyle = '#fff'
    ctx.lineWidth = 2.2
    ctx.beginPath()
    ctx.moveTo(120, 300) // 左下
    ctx.quadraticCurveTo(220, 388, 383, 340) // 右下
    ctx.stroke()
    ctx.closePath()

    // stitchここから
    ctx.beginPath()
    ctx.setLineDash([3, 3])
    ctx.strokeStyle = state.stitch.color
    ctx.lineWidth = 1.2
    ctx.moveTo(120, 294) // 左下
    ctx.quadraticCurveTo(220, 382, 383, 334) // 右下

    // ctx.quadraticCurveTo()
    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#383838'
  }
  switch (state.openingPattern.value) {
    case 'quarterCut':
      break
    case 'lowCut':
    case 'mountainMiddleCut':
    case 'horizontalMiddleCut':
    default:
      lowCutReinforcement(ctx, state)
      break
  }
}

const mesh = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const { isMesh } = getUpperMaterial(state)
  if (!isMesh) return

  ctx.fillStyle = '#ccc'
  const lowCutAndMiddleCutMainUnitMesh = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    generateMesh(ctx, 7, -6, 387)
    generateMesh(ctx, 10, -3, 393)
    generateMesh(ctx, 13, 0, 400)
    generateMesh(ctx, 15, 3, 407)
    generateMesh(ctx, 20, 5, 416)
    generateMesh(ctx, 24, 4, 428)
    generateMesh(ctx, 24, 4, 439)
    generateMesh(ctx, 24, 4, 450)

    generateMesh(ctx, 24, 4, 461)
    generateMesh(ctx, 28, 4, 472)
    generateMesh(ctx, 28, 4, 483)
    generateMesh(ctx, 28, 4, 494)
    generateMesh(ctx, 33, 4, 505)

    generateMesh(ctx, 30, 17, 502)
    generateMesh(ctx, 33, 28, 502)
    generateMesh(ctx, 33, 39, 501)
    generateMesh(ctx, 28, 58, 495)
    generateMesh(ctx, 28, 58, 506)
    generateMesh(ctx, 28, 73, 502)
    generateMesh(ctx, 28, 82, 503)
    generateMesh(ctx, 28, 88, 508)
    generateMesh(ctx, 28, 106, 499)
    generateMesh(ctx, 29, 106, 510)
    generateMesh(ctx, 13, 227, 400)
    generateMesh(ctx, 10, 227, 411)
    generateMesh(ctx, 13, 227, 422)
    generateMesh(ctx, 13, 227, 433)
    generateMesh(ctx, 5, 302, 367)
  }

  switch (state.openingPattern.value) {
    case 'quarterCut':
      generateMesh(ctx, 7, -6, 387)
      generateMesh(ctx, 10, -3, 393)
      generateMesh(ctx, 13, 0, 400)
      generateMesh(ctx, 25, 3, 407)
      generateMesh(ctx, 30, 5, 416)
      generateMesh(ctx, 31, 4, 428)
      generateMesh(ctx, 31, 4, 439)
      generateMesh(ctx, 32, 4, 450)
      generateMesh(ctx, 33, 4, 461)
      generateMesh(ctx, 34, 4, 472)
      generateMesh(ctx, 34, 4, 483)
      generateMesh(ctx, 35, 4, 494)
      generateMesh(ctx, 36, 4, 505)
      generateMesh(ctx, 35, 19, 501)
      generateMesh(ctx, 34, 34, 496)
      generateMesh(ctx, 33, 48, 494)
      generateMesh(ctx, 33, 58, 495)
      generateMesh(ctx, 32, 58, 506)
      generateMesh(ctx, 29, 81, 493)
      generateMesh(ctx, 28, 88, 497)
      generateMesh(ctx, 28, 98, 497)
      generateMesh(ctx, 28, 110, 496)

      generateMesh(ctx, 29, 120, 496)
      generateMesh(ctx, 13, 227, 400)
      generateMesh(ctx, 14, 227, 411)
      generateMesh(ctx, 15, 227, 422)
      generateMesh(ctx, 18, 227, 433)
      generateMesh(ctx, 5, 302, 367)
      generateMesh(ctx, 5, 321, 358)
      generateMesh(ctx, 5, 334, 354)
      generateMesh(ctx, 5, 348, 350)
      generateMesh(ctx, 5, 362, 346)
      generateMesh(ctx, 5, 372, 344)

      // tongue // ベロ表
      generateMesh(ctx, 9, 190, 229)
      generateMesh(ctx, 11, 191, 237)
      generateMesh(ctx, 9, 196, 243)
      generateMesh(ctx, 9, 200, 250)
      generateMesh(ctx, 9, 204, 257)
      generateMesh(ctx, 9, 207, 264)
      generateMesh(ctx, 9, 212, 270)
      generateMesh(ctx, 8, 220, 273)
      generateMesh(ctx, 7, 227, 277)
      generateMesh(ctx, 7, 233, 282)
      generateMesh(ctx, 6, 242, 284)
      generateMesh(ctx, 5, 252, 286)
      generateMesh(ctx, 3, 263, 284)
      // generateMesh(ctx, 5, )
      break
    case 'mountainMiddleCut':
      lowCutAndMiddleCutMainUnitMesh(ctx, state)
      // tongue // ベロ表
      generateMesh(ctx, 1, 168, 230)
      generateMesh(ctx, 3, 175, 226)
      generateMesh(ctx, 2, 187, 222)
      break
    case 'horizontalMiddleCut':
      lowCutAndMiddleCutMainUnitMesh(ctx, state)
      // tongue // ベロ表
      generateMesh(ctx, 2, 157, 237)
      generateMesh(ctx, 5, 167, 234)
      generateMesh(ctx, 3, 178, 233)
      generateMesh(ctx, 2, 187, 232)
      generateMesh(ctx, 1, 196, 232)
      break
    case 'lowCut':
    default:
      lowCutAndMiddleCutMainUnitMesh(ctx, state)
      // tongue // ベロ表
      generateMesh(ctx, 2, 152, 241)
      generateMesh(ctx, 7, 160, 243)
      generateMesh(ctx, 6, 166, 247)
      generateMesh(ctx, 5, 173, 251)
      generateMesh(ctx, 4, 182, 254)
      generateMesh(ctx, 4, 187, 260)
      generateMesh(ctx, 4, 193, 267)
      generateMesh(ctx, 3, 199, 273)
      generateMesh(ctx, 3, 206, 279)
      generateMesh(ctx, 2, 213, 283)
      generateMesh(ctx, 2, 220, 289)
      // generateMesh(ctx, 3,)
      break
  }
}

const embroideryLeftHeal = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  // healSide
  const healSideEmbroidery = state.embroideries.find((embroidery) => embroidery.position.value === 'healSideLeftFoot')
  if (healSideEmbroidery) {
    ctx.save()
    ctx.rotate((-15 * Math.PI) / 180)
    shoesHealEmbroidery(ctx, healSideEmbroidery, -90, 25)
    ctx.restore()
  }

  // healCenter
  const healCenterEmbroidery = state.embroideries.find((embroidery) => embroidery.position.value === 'healCenterLeftFoot')
  if (healCenterEmbroidery) {
    ctx.save()
    ctx.rotate((-7 * Math.PI) / 180)
    leftFootTransform(ctx, () => {
      shoesHealEmbroidery(ctx, healCenterEmbroidery, -25, -10)
    })
    ctx.restore()
  }

  // healDecoration
  const healDecorationEmbroidery = state.embroideries.find((embroidery) => embroidery.position.value === 'healDecoration')
  if (healDecorationEmbroidery) {
    const drawPosition = {
      quarterCut: { x: 85, y: -180 },
      lowCut: { x: 88, y: -195 },
      unselected: { x: 88, y: -195 }, // 未選択時の描画
      mountainMiddleCut: { x: 88, y: -195 },
      horizontalMiddleCut: { x: 88, y: -195 }
    }

    ctx.save()
    // ctx.rotate((0 * Math.PI) / 180)
    leftFootTransform(ctx, () => {
      shoesHealDecorationEmbroidery(
        ctx,
        healDecorationEmbroidery,
        drawPosition[state.openingPattern.value].x,
        drawPosition[state.openingPattern.value].y
      )
    })
    // ctx.restore()
  }
}
const embroideryRight = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  // healSide
  const healSideEmbroidery = state.embroideries.find((embroidery) => embroidery.position.value === 'healSideRightFoot')
  if (healSideEmbroidery) {
    ctx.save()
    ctx.rotate((15 * Math.PI) / 180)
    shoesHealEmbroidery(ctx, healSideEmbroidery, 380, -200)
    ctx.restore()
  }

  // healCenter
  const healCenterEmbroidery = state.embroideries.find((embroidery) => embroidery.position.value === 'healCenterRightFoot')
  if (healCenterEmbroidery) {
    ctx.save()
    ctx.rotate((7 * Math.PI) / 180)
    rightFootTransform(ctx, () => {
      shoesHealEmbroidery(ctx, healCenterEmbroidery, 300, -110)
    })
    ctx.restore()
  }

  // healDecoration
  const healDecorationEmbroidery = state.embroideries.find((embroidery) => embroidery.position.value === 'healDecoration')
  const drawPosition = {
    quarterCut: { x: 231, y: -180 },
    lowCut: { x: 225, y: -195 },
    unselected: { x: 225, y: -195 }, // 未選択時の描画
    mountainMiddleCut: { x: 225, y: -195 },
    horizontalMiddleCut: { x: 225, y: -195 }
  }

  if (healDecorationEmbroidery) {
    ctx.save()
    // ctx.rotate((0 * Math.PI) / 180)
    rightFootTransform(ctx, () => {
      shoesHealDecorationEmbroidery(
        ctx,
        healDecorationEmbroidery,
        drawPosition[state.openingPattern.value].x,
        drawPosition[state.openingPattern.value].y
      )
    })
    // ctx.restore()
  }
}

export const drawAtomsShoesRearSurfaceLeftFoot = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.lineWidth = 1.0
  canvasResetter(ctx) // リセット
  tongue(ctx, state) // ベロ

  mainUnit(ctx, state) // クォーターカット本体
  middleCut(ctx, state) // ミドルカット
  mesh(ctx, state)
  atomsDesign(ctx, state) // ATOMSマーク
  openingPatternReinforcement(ctx, state) // オープニング補強
  vampStrapReinforcement(ctx, state) // 紐・ベルト
  vampStraps(ctx, state) //
  foldingTongue(ctx, state) // ベロ
  healDecoration(ctx, state) // かかと飾り
  healMainParts(ctx, state) // かかと本体
  outSole(ctx, state) // アウトソール

  embroideryLeftHeal(ctx, state)
}

export const drawAtomsShoesRearSurfaceRightFoot = (ctx: CanvasRenderingContext2D | null, state: ShoesState, canvasWidth: number): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.lineWidth = 1.0
  startInversion(ctx, canvasWidth)

  // canvasResetter(ctx) // リセット
  tongue(ctx, state) // ベロ
  mainUnit(ctx, state) // クォーターカット本体
  middleCut(ctx, state) // ミドルカット
  mesh(ctx, state)
  atomsDesign(ctx, state) // ATOMSマーク
  openingPatternReinforcement(ctx, state) // オープニング補強
  vampStrapReinforcement(ctx, state) // 紐・ベルト
  vampStraps(ctx, state) //
  foldingTongue(ctx, state) // ベロ
  healDecoration(ctx, state) // かかと飾り
  healMainParts(ctx, state) // かかと本体
  outSole(ctx, state) // アウトソール

  undoInversion(ctx, canvasWidth)

  embroideryRight(ctx, state)
}
